import Vue from "vue";
import StoriesItem from "~/stories_widget/models/StoriesItem";
import {Commit, GetterTree, Module as VuexModule} from "vuex";
import RootState from "./rootState";
import {
    IWidgetStoriesOptions,
    ReaderCloseButtonPosition, ReaderOptions, ReaderSwipeStyle,
    SliderCardViewVariant,
    SliderOptions
} from "../models/WidgetStoriesOptions";
import {WidgetStoriesOptions} from "../models/WidgetStoriesOptions";

import isBoolean from 'lodash/isBoolean';
import first from "lodash/first";
import isNumber from "lodash/isNumber";
import NarrativeContext from "~/stories_widget/models/NarrativeContext";
import {IData} from "~/stories_widget/models/AbstractModel";
import {debug} from "~/stories_widget/util/debug";
import merge from "lodash/merge";
import {Promise} from "es6-promise";
import {rejects} from "assert";

export enum STORY_LIST_TYPE {
    default,
    onboarding,
    favorite
}

export interface StoriesState {
    stories: Array<StoriesItem>;
    storiesIds: Array<Array<number>>; // зависимость от типа списка
    storiesContext: NarrativeContext | null;

    storyId: number | null;
    showStoriesView: boolean;

    activeStoryIndex: number | null;
    activeSlideElementQuiz: any;
    activeSlideElementQuizGrouped: any;
    activeSlideElementTest: any;
    activeSlideElementQuest: any;
    activeSlideElementDateCountdown: any;
    modeDesktop: boolean;

    options: IWidgetStoriesOptions;

    hasShare: boolean;

    muted: boolean;
    nextFlippingStoryId: Nullable<number>;
    activeListType: STORY_LIST_TYPE;
    sliderWidth: Nullable<number>;
    showStoriesFavoriteReader: boolean;
}


interface StoriesAction {
    commit: any;
    state: StoriesState;
}

const module: VuexModule<StoriesState, RootState> = {
    namespaced: true,
    state: {
        stories: [], // Map
        storiesIds: [[], [], []],
        storiesContext: null,

        storyId: null,
        showStoriesView: false,
        activeStoryIndex: null,
        activeSlideElementQuiz: undefined,
        activeSlideElementQuizGrouped: undefined,
        activeSlideElementTest: undefined,
        activeSlideElementQuest: undefined,
        activeSlideElementDateCountdown: undefined,
        modeDesktop: false,

        hasShare: false,

        options: {

            hasLike: false,
            hasFavorite: false,

            userId: null,
            tags: null,
            lang: null,

            reader: {
                closeButtonPosition: ReaderCloseButtonPosition.RIGHT,
                scrollStyle: ReaderSwipeStyle.FLAT,
                loader: {
                    default: {
                        color: null,
                        accentColor: null,
                    },
                    custom: null
                }
            },

            slider: {
                title: {
                    content: '',
                    color: '#ffffff',
                    font: 'normal',
                    marginBottom: 20,
                },
                card: {
                    title: {
                        font: 'normal',
                        color: '#ffffff',
                        padding: 15,
                    },
                    gap: 10,
                    height: 70,
                    variant: SliderCardViewVariant.CIRCLE,
                    border: {
                        radius: 0,
                        color: 'black',
                        width: 2,
                        gap: 3,
                    },
                    boxShadow: null,
                    opacity: null,
                    mask: {
                        color: null,
                    },
                    read: {
                        border: {
                            radius: null,
                            color: null,
                            width: null,
                            gap: null,
                        },
                        boxShadow: null,
                        opacity: null,
                        mask: {
                            color: null,
                        },
                    },
                },
                favoriteCard: {
                    title: {
                        content: 'Избранное',
                        font: 'normal',
                        color: '#000',
                        padding: 15,
                    },
                    gap: 10,
                    height: 70,
                    variant: SliderCardViewVariant.CIRCLE,
                    border: {
                        radius: 0,
                        color: 'black',
                        width: 2,
                        gap: 3,
                    },
                    boxShadow: null,
                    opacity: null,
                    mask: {
                        color: null,
                    },
                    read: {
                        border: {
                            radius: null,
                            color: null,
                            width: null,
                            gap: null,
                        },
                        boxShadow: null,
                        opacity: null,
                        mask: {
                            color: null,
                        },
                    },
                },
                sidePadding: 20,
                topPadding: 20,
                bottomPadding: 20,
                bottomMargin: 17,
                layout: {
                    height: 0,
                    backgroundColor: 'transparent'
                },
                navigation: {
                    showControls: false,
                    controlsSize: 48,
                    controlsBackgroundColor: 'white',
                    controlsColor: 'black'
                },
            },
            placeholders: {},
            favorite: {
                title: {
                    content: 'Сохраненные истории',
                }
            }
        },

        muted: true,
        nextFlippingStoryId: null,
        activeListType: STORY_LIST_TYPE.default,
        sliderWidth: null,
        showStoriesFavoriteReader: false,
    },
    getters: {
        options: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): IWidgetStoriesOptions => state.options,

        sliderOptions: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): SliderOptions => state.options.slider,
        readerOptions: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): ReaderOptions => state.options.reader,

        storiesGap: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): number => state.options.slider.card.gap,
        storiesHeight: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): number => state.options.slider.card.height,

        storiesStyle: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): SliderCardViewVariant => state.options.slider.card.variant,

        storiesListSidePadding: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): number => state.options.slider.sidePadding,
        storiesListTopPadding: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): number => state.options.slider.topPadding,
        storiesListBottomPadding: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): number => state.options.slider.bottomPadding,
        storiesListBottomMargin: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): number => state.options.slider.bottomMargin,

        storiesBackgroundColor: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): string => state.options.slider.layout.backgroundColor,

        storiesBorderNotReadColor: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): string => state.options.slider.card.border.color,
        storiesBorderReadColor: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): Nullable<string> => state.options.slider.card.read.border.color,
        storiesListBorderNotReadWidth: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): number => state.options.slider.card.border.width,
        storiesListBorderReadWidth: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): Nullable<number> => state.options.slider.card.read.border.width,
        storiesListBorderGapNotRead: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): number => state.options.slider.card.border.gap,
        storiesListBorderGapRead: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): Nullable<number> => state.options.slider.card.read.border.gap,
        storiesListBorderRadiusNotRead: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): number => state.options.slider.card.border.radius,
        storiesListBorderRadiusRead: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): Nullable<number> => state.options.slider.card.read.border.radius,

        storiesListItemBoxShadow: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): Nullable<string> => state.options.slider.card.boxShadow,
        storiesListItemBoxShadowRead: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): Nullable<string> => state.options.slider.card.read.boxShadow,
        storiesListItemOpacity: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): Nullable<number> => state.options.slider.card.opacity,
        storiesListItemOpacityRead: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): Nullable<number> => state.options.slider.card.read.opacity,


        transformStyle: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): ReaderSwipeStyle => state.options.reader.scrollStyle,
        closeButtonPosition: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): ReaderCloseButtonPosition => state.options.reader.closeButtonPosition,
        hasLike: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): boolean => state.options.hasLike,
        hasFavorite: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): boolean => state.options.hasFavorite,
        hasShare: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): boolean => state.hasShare,

        storiesListControls: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): boolean => state.options.slider.navigation.showControls,
        storiesListControlsSize: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): number => state.options.slider.navigation.controlsSize,
        storiesListControlsBackgroundColor: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): string => state.options.slider.navigation.controlsBackgroundColor,
        storiesListControlsColor: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): string => state.options.slider.navigation.controlsColor,


        // deviceId: state => state.deviceId,
        storyId: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): number | null => state.storyId,
        activeStories: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): Array<StoriesItem> => {
            // console.log('activeStories', state.storiesIds, state.activeListType, state.stories)
            return state.storiesIds[state.activeListType].map((id: number) => state.stories[id]).filter((_: StoriesItem) => _.hide_in_reader !== true)
        },
        onboardingActiveStories: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): Array<StoriesItem> => {
            return state.storiesIds[STORY_LIST_TYPE.onboarding].map((id: number) => state.stories[id]).filter((_: StoriesItem) => _.hide_in_reader !== true)
        },
        activeStoriesIds: (state: StoriesState): Array<number> => {
            return state.storiesIds[state.activeListType];
        },
        onboardingActiveStoriesIds: (state: StoriesState): Array<number> => {
            return state.storiesIds[STORY_LIST_TYPE.onboarding];
        },
        firstActiveStoryId: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): number | null => {
            const value = first(state.storiesIds[state.activeListType]);
            if (isNumber(value)) {
                return value;
            }
            return null;
        },
        loadedStories: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): Array<StoriesItem> => { // todo объединить , просто при загрузке данных stories - добавлять их к оснонвому хранидищзу
            return state.storiesIds[state.activeListType].map((id: number) => state.stories[id])
            // filter убирает все undefined из массива
            // return getters.activeStoriesIds.map(id => state.storiesData[id]).filter(_ => _)
        },
        defaultLoadedStories: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): Array<StoriesItem> => { // todo объединить , просто при загрузке данных stories - добавлять их к оснонвому хранидищзу
            return state.storiesIds[STORY_LIST_TYPE.default].map((id: number) => state.stories[id])
            // filter убирает все undefined из массива
            // return getters.activeStoriesIds.map(id => state.storiesData[id]).filter(_ => _)
        },
        onboardingLoadedStories: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): Array<StoriesItem> => { // todo объединить , просто при загрузке данных stories - добавлять их к оснонвому хранидищзу
            return state.storiesIds[STORY_LIST_TYPE.onboarding].map((id: number) => state.stories[id])
            // filter убирает все undefined из массива
            // return getters.activeStoriesIds.map(id => state.storiesData[id]).filter(_ => _)
        },
        favoriteLoadedStories: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): Array<StoriesItem> => { // todo объединить , просто при загрузке данных stories - добавлять их к оснонвому хранидищзу
            return state.storiesIds[STORY_LIST_TYPE.favorite].map((id: number) => state.stories[id])
            // filter убирает все undefined из массива
            // return getters.activeStoriesIds.map(id => state.storiesData[id]).filter(_ => _)
        },


        // общий список всех сторис
        items: (state: StoriesState) => state.stories,

        // + доп фильтр по локальному состоянию прочитанности
        onboardingStoriesIds: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): Array<number> => {
            return state.storiesIds[STORY_LIST_TYPE.onboarding].filter(id => {
                const item = state.stories[id];
                return !item.isOpened;
            });
        },

        activeStoryIndex: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): number | null => state.activeStoryIndex,

        activeSlideElementQuiz: (state: StoriesState, getters: GetterTree<StoriesState, RootState>) => state.activeSlideElementQuiz,
        activeSlideElementQuizGrouped: (state: StoriesState, getters: GetterTree<StoriesState, RootState>) => state.activeSlideElementQuizGrouped,
        activeSlideElementTest: (state: StoriesState, getters: GetterTree<StoriesState, RootState>) => state.activeSlideElementTest,
        activeSlideElementQuest: (state: StoriesState, getters: GetterTree<StoriesState, RootState>) => state.activeSlideElementQuest,
        activeSlideElementDateCountdown: (state: StoriesState, getters: GetterTree<StoriesState, RootState>) => state.activeSlideElementDateCountdown,

        modeDesktop: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): boolean => state.modeDesktop,

        storiesContext: (state: StoriesState, getters: GetterTree<StoriesState, RootState>): NarrativeContext | null => state.storiesContext,

        muted: (state: StoriesState): boolean => state.muted,
        nextFlippingStoryId: (state: StoriesState): Nullable<number> => state.nextFlippingStoryId,

        placeholders: (state: StoriesState): Dict => state.options.placeholders,

        sliderWidth: (state: StoriesState): Nullable<number> => state.sliderWidth,
        showStoriesFavoriteReader: (state: StoriesState): boolean => state.showStoriesFavoriteReader,

    },
    /** ns https://morningstar.engineering/managing-your-vue-js-applications-state-with-vuex-part-2-5e5c3a0cd507 */
    /** https://stackoverflow.com/questions/40390411/vuex-2-0-dispatch-versus-commit */

    // synchronous and freeze frontend
    mutations: {

        setOptions: (state: StoriesState, options: IWidgetStoriesOptions) => {
            state.options = merge(state.options, options);
        },

        setHasShare: (state: StoriesState, status: boolean) => {
            if (isBoolean(status)) {
                state.hasShare = status;
            } else {
                // debug msg
            }
        },

        setSharedShowStoriesView: (state: StoriesState, status: boolean) => {
            if (isBoolean(status)) {
                state.showStoriesView = status;
            } else {
                // debug msg
            }
        },

        setStoriesSlides: (state: StoriesState, models: Array<StoriesItem>) => {
            for (let key in models) {
                let item = models[key];
                if (item) {
                    item.slidesLoaded = true;
                    Vue.set(state.stories, item.id, item);
                    // state.storiesIds.push(item.id)
                }
            }
        },

        setStories: (state: StoriesState, models: Array<StoriesItem>) => {
            for (let key in models) {
                // let item: StoriesItem = StoriesItem.createInstance(StoriesItem, stories[key]);
                let item = models[key];
                if (item && state.storiesIds[STORY_LIST_TYPE.default].indexOf(item.id) === -1) {
                    if (!state.stories[item.id]) {
                        Vue.set(state.stories, item.id, item);
                    }
                    state.storiesIds[STORY_LIST_TYPE.default].push(item.id)
                }

                // debug(item)

            }


            // if (isArray(stories)) {
            //     stories.forEach(item => {
            //         if (item) {
            //             Vue.set(state.stories, item.id, item)
            //
            //             state.lists['stories'].push(item.id)
            //
            //         }
            //     })
            // }

        },

        setStoriesContext: (state: StoriesState, model: NarrativeContext) => {
            state.storiesContext = model;
        },

        SET_ACTIVE_STORY: (state: StoriesState, id: number) => {
            state.storyId = id;
            state.showStoriesView = true;
        },

        UPDATE_STORIES_ACTIVE_INDEX: (state: StoriesState, activeStoryIndex) => {
            state.activeStoryIndex = activeStoryIndex;
        },

        SET_ACTIVE_ELEMENT_QUIZ: (state: StoriesState, activeSlideElementQuiz) => {
            state.activeSlideElementQuiz = activeSlideElementQuiz;
        },
        SET_ACTIVE_ELEMENT_QUIZ_GROUPED: (state: StoriesState, activeSlideElementQuiz) => {
            state.activeSlideElementQuizGrouped = activeSlideElementQuiz;
        },
        SET_ACTIVE_ELEMENT_TEST: (state: StoriesState, activeSlideElementTest) => {
            state.activeSlideElementTest = activeSlideElementTest;
        },
        SET_ACTIVE_ELEMENT_QUEST: (state: StoriesState, activeSlideElementQuest) => {
            state.activeSlideElementQuest = activeSlideElementQuest;
        },
        SET_ACTIVE_ELEMENT_DATE_COUNTDOWN: (state: StoriesState, activeSlideElementDateCountdown) => {
            state.activeSlideElementDateCountdown = activeSlideElementDateCountdown;
        },

        ENABLE_DESKTOP_MODE: (state: StoriesState) => {
            state.modeDesktop = true;
        },
        DISABLE_DESKTOP_MODE: (state: StoriesState) => {
            state.modeDesktop = false;
        },

        setStoryLike: (state: StoriesState, {id, like}) => {
            let story = state.stories[id];
            if (story !== undefined) {
                story.like = like;
            }
        },

        setStoryFavorite: (state: StoriesState, {id, favorite}) => {
            let story = state.stories[id];
            if (story !== undefined) {
                story.favorite = !!favorite;
            }
        },

        setStorySharePath: (state: StoriesState, {id, path}) => {
            let story = state.stories[id];
            if (story !== undefined) {
                story.sharePath = path;
            }
        },

        setMuted: (state: StoriesState, value: boolean) => {
            state.muted = value;
        },

        setNextFlippingStory: (state: StoriesState, value: Nullable<number>) => {
            state.nextFlippingStoryId = value;
        },

        addDefaultPlaceholders: (state: StoriesState, value: Dict) => {
            state.options.placeholders = Object.assign(value, state.options.placeholders);
        },


        // updateDeviceId(state, deviceId) {
        //     state.deviceId = deviceId;
        // },
        // updatemail(state, email) {
        //     state.email = email;
        // }

        setOnboardingStories: (state: StoriesState, models: Array<StoriesItem>) => {
            for (let key in models) {
                // let item: StoriesItem = StoriesItem.createInstance(StoriesItem, stories[key]);
                let item = models[key];

                // списки - делать мапой с двумя ключами - для stories и для onboarding
                if (item && state.storiesIds[STORY_LIST_TYPE.onboarding].indexOf(item.id) === -1) {
                    if (!state.stories[item.id]) {
                        Vue.set(state.stories, item.id, item);
                    }
                    state.storiesIds[STORY_LIST_TYPE.onboarding].push(item.id)
                }

                // debug(item)

            }


            // if (isArray(stories)) {
            //     stories.forEach(item => {
            //         if (item) {
            //             Vue.set(state.stories, item.id, item)
            //
            //             state.lists['stories'].push(item.id)
            //
            //         }
            //     })
            // }

        },

        setFavoriteStories: (state: StoriesState, models: Array<StoriesItem>) => {
            const ids = models.map(item => item.id);
            models.forEach(item => Vue.set(state.stories, item.id, item));
            Vue.set(state.storiesIds, STORY_LIST_TYPE.favorite, ids);
        },

        // part update of list
        updateFavoriteStoriesList: (state: StoriesState, {id, favorite}) => {
            console.log('updateFavoriteStoriesList', {id, favorite});
            if (favorite && state.storiesIds[STORY_LIST_TYPE.favorite].indexOf(id) === -1) {
                const ids = [id, ...state.storiesIds[STORY_LIST_TYPE.favorite]];
                Vue.set(state.storiesIds, STORY_LIST_TYPE.favorite, ids);
                console.log('updateFavoriteStoriesList', {id, action: 'unshift'}, state.storiesIds[STORY_LIST_TYPE.favorite]);
            } else if (!favorite && state.storiesIds[STORY_LIST_TYPE.favorite].indexOf(id) !== -1) {
                const ids = state.storiesIds[STORY_LIST_TYPE.favorite].filter(value => value !== id);
                Vue.set(state.storiesIds, STORY_LIST_TYPE.favorite, ids);
                console.log('updateFavoriteStoriesList', {id, action: 'delete'}, state.storiesIds[STORY_LIST_TYPE.favorite]);
            }
        },



        SET_STORY_LIST_TYPE: (state: StoriesState, type: STORY_LIST_TYPE) => {
            state.activeListType = type;
        },
        setSliderWidth: (state: StoriesState, sliderWidth: number) => {
            state.sliderWidth = sliderWidth;
        },
        setShowStoriesFavoriteReader: (state: StoriesState, value: boolean) => {
            state.showStoriesFavoriteReader = value;
        },
        setStoryOpened: (state: StoriesState, {id, value}: {id: number, value: boolean}) => {
            let story = state.stories[id];
            if (story !== undefined) {
                story.isOpened = value;
            }
        },

    },
    // async
    actions: {
        // emailupdate(context, email) {
        //     context.commit('updatemail', email);
        // },
        // updateDeviceId(context, deviceId) {
        //     context.commit('updateDeviceId', deviceId);
        // }

        /** загрузка всей стркутуры данных stories */
        FETCH_STORY: ({commit, state}: StoriesAction, id: number) => {
            // если story не загружена или нету слайдов
            if (!state.stories[id] || !state.stories[id].slidesLoaded) {
                return StoriesItem.fetch(id, state.options.placeholders).then((val) => commit('setStoriesSlides', [val]));
            } else {
                return Promise.resolve();
            }


            // if (!state.storiesData[id]) {
            // return StoriesItem.fetch(id).then((val) => commit('setStoriesSlides', [val]));
            // } else {
            //     return Promise.resolve()
            // }
        },

        /**
         * Список нарративов без слайдов
         * @param commit
         * @param state
         * @constructor
         */
        FETCH_STORIES: ({commit, state}: StoriesAction) => {
            return StoriesItem.fetchList(state.options.placeholders, state.options.tags).then((dataProvider) => {
                commit('setStories', dataProvider.models);
            })
        },

        /**
         * Список избранных сторис
         * @param commit
         * @param state
         * @constructor
         */
        FETCH_FAVORITE_STORIES: ({commit, state}: StoriesAction) => {
            return StoriesItem.fetchList(state.options.placeholders, null, true).then((dataProvider) => {
                commit('setFavoriteStories', dataProvider.models);
            })
        },

        /**
         * Загружает сразу все нарратиавы со слайдами (по одному)
         * @param commit
         * @param state
         * @param ids
         * @constructor
         */
        FETCH_STORIES_SLIDES: ({commit, state}: StoriesAction, ids: Array<number>) => {

            debug('FETCH_STORIES_SLIDES');
            debug(ids);

            const now = new Date().getTime();

            ids = ids.filter(id => {
                // const item = state.storiesData[id]
                // if (!item) {
                //     return true
                // }
                const item = state.stories[id];
                if (now - item.receiveTime > 1000 * 60 * 60) { // 1 hour
                    return true;
                }

                if (!item.slidesLoaded) {
                    return true;
                }

                return false
            });
            debug(ids);

            if (ids.length > 0) {
                return StoriesItem.fetchWithSlides(ids, state.options.placeholders).then(items => commit('setStoriesSlides', items))
            } else {
                return Promise.resolve()
            }

        },

        UPDATE_STORIES_ACTIVE_INDEX: ({
                                          commit,
                                          state
                                      }: StoriesAction, activeStoryIndex) =>
            commit('UPDATE_STORIES_ACTIVE_INDEX', activeStoryIndex),

        SET_ACTIVE_ELEMENT_QUIZ: ({
                                      commit,
                                      state
                                  }: StoriesAction, activeSlideElementQuiz) =>
            commit('SET_ACTIVE_ELEMENT_QUIZ', activeSlideElementQuiz),
        SET_ACTIVE_ELEMENT_QUIZ_GROUPED: ({
                                              commit,
                                              state
                                          }: StoriesAction, activeSlideElementQuiz) =>
            commit('SET_ACTIVE_ELEMENT_QUIZ_GROUPED', activeSlideElementQuiz),
        SET_ACTIVE_ELEMENT_TEST: ({
                                      commit,
                                      state
                                  }: StoriesAction, activeSlideElementTest) =>
            commit('SET_ACTIVE_ELEMENT_TEST', activeSlideElementTest),
        SET_ACTIVE_ELEMENT_QUEST: ({
                                      commit,
                                      state
                                  }: StoriesAction, activeSlideElementQuest) =>
            commit('SET_ACTIVE_ELEMENT_QUEST', activeSlideElementQuest),

        SET_ACTIVE_ELEMENT_DATE_COUNTDOWN: ({
                                      commit,
                                      state
                                  }: StoriesAction, activeSlideElementDateCountdown) =>
            commit('SET_ACTIVE_ELEMENT_DATE_COUNTDOWN', activeSlideElementDateCountdown),


        UPDATE_STORY_OPENED: ({
                                  commit,
                                  state
                              }: StoriesAction, payload: { id: number, value: boolean }) =>
            commit('setStoryOpened', payload),


        UPDATE_STORY_FAVORITE_INTERNAL: ({commit, state }: StoriesAction, payload: { id: number, value: boolean }) => {
            commit('setStoryFavorite', {id: payload.id, favorite: payload.value});
            commit('updateFavoriteStoriesList', {id: payload.id, favorite: payload.value});
        },

        /**
         * Контекст для всех нарративов из списка
         * @param commit
         * @param state
         * @param ids
         * @constructor
         */
        FETCH_STORIES_CONTEXT: ({commit, state}: StoriesAction, ids: Array<number>) => {
            // todo могут быть разные ids для разных списков
            if (!state.storiesContext) {
                return NarrativeContext.fetch(ids).then((val) => {
                    commit('setStoriesContext', val);
                })
            } else {
                return Promise.resolve();
            }
        },

        UPDATE_STORY_LIKE: ({commit, state}: StoriesAction, {id, like}) => {
            StoriesItem.update(`story-like/${id}`, {value: like}).then((data: any) => {
                if (data.like !== undefined) {
                    commit('setStoryLike', {id, like: data.like})
                }

            }, () => {
                // api or network error
            })
        },

        UPDATE_STORY_FAVORITE: ({commit, state}: StoriesAction, {id, favorite}) => {
            return new Promise((resolve, reject) => {
                if (state.stories[id]) {
                    const prevState = state.stories[id].favorite;
                    commit('setStoryFavorite', {id, favorite});
                    // commit('updateFavoriteStoriesList', {id, favorite});
                    StoriesItem.update(`story-favorite/${id}`, {value: favorite}).then((data: any) => {
                        if (data.favorite !== undefined) {
                            commit('setStoryFavorite', {id, favorite: Boolean(data.favorite)});
                            // commit('updateFavoriteStoriesList', {id, favorite: Boolean(data.favorite)});
                            resolve(data.favorite);
                        } else {
                            // return prev state
                            commit('setStoryFavorite', {id, favorite: prevState});
                            // commit('updateFavoriteStoriesList', {id, favorite: prevState});
                            reject(new Error('Bad response from server'));
                        }
                    }, (e) => {
                        // api or network error

                        // return prev state
                        commit('setStoryFavorite', {id, favorite: prevState});
                        // commit('updateFavoriteStoriesList', {id, favorite: prevState});
                        reject(e);
                    })
                } else {
                    reject(new Error('Story not found in state'));
                }
            });

        },

        GET_SHARE_PATH: ({commit, state}: StoriesAction, {id}) => {
            return StoriesItem.update(`story-share/${id}`, {}, 'get').then((data: any) => {
                if (data.url !== undefined) {
                    commit('setStorySharePath', {id, path: data.url})
                }

            }, () => {
                // api or network error
            })
        },

        MUTE: ({commit, state}: StoriesAction) => commit('setMuted', true),
        UNMUTE: ({commit, state}: StoriesAction) => commit('setMuted', false),



        /**
         * Список сторис для онбординга
         * @param commit
         * @param state
         * @constructor
         */
        FETCH_ONBOARDING_STORIES: ({commit, state}: StoriesAction) => {
            return StoriesItem.fetchOnboardingList(state.options.placeholders, state.options.tags).then((dataProvider) => {
                commit('setOnboardingStories', dataProvider.models);
            })
        },

        /**
         * Загружает сразу все нарратиавы со слайдами (по одному)
         * @param commit
         * @param state
         * @param ids
         * @constructor
         */
        FETCH_ONBOARDING_STORIES_SLIDES: ({commit, state}: StoriesAction, ids: Array<number>) => {

            debug('FETCH_ONBOARDING_STORIES_SLIDES');
            debug(ids);

            const now = new Date().getTime();

            ids = ids.filter(id => {
                // const item = state.storiesData[id]
                // if (!item) {
                //     return true
                // }
                const item = state.stories[id];
                if (now - item.receiveTime > 1000 * 60 * 60) { // 1 hour
                    return true;
                }

                if (!item.slidesLoaded) {
                    return true;
                }

                return false
            });
            debug(ids);

            if (ids.length > 0) {
                return StoriesItem.fetchOnboardingListWithSlides(ids, state.options.placeholders).then(items => commit('setStoriesSlides', items))
            } else {
                return Promise.resolve()
            }

        },


    }
};

export default module;
